module.exports = __webpack_public_path__ + "img/58.48bda004.jpg";